import React from 'react';

import Pic1 from '../../InstallImages/Modules/Hyundai400W';

const moduleLink = <a href="https://www.dropbox.com/s/iahfdqpy06uzj55/Hyundai%2C%20Q_CELLS_Data_sheet_Q.PEAK_DUO_L-G7.2_385-405_2019-08_Rev02_AU.pdf?dl=0" rel="noopener noreferrer" target="_blank">Data Sheet</a>;

const Module = () => (
    <div>
        <div className="col span-1-of-2">
            <Pic1 />
        </div>
        <div className="col span-1-of-2">
            <p className="specsText">
                Hyundai is one of the most recognizable names in the solar industry. The company started its solar business in 2005, and its solar panels are produced by a separate branch of the company that owns Hyundai Motors. Even though their panels are manufactured in South Korea, but their products are generally considered to be an great value homeowners and businesses a like looking for a low-cost solar installation.
            </p>
            <ul>
                <h2>Inclusive 12-year product warranty and 25-year linear performance warranty2.</h2>
                <li className="specsText">Initial year: 98%</li>
                <li className="specsText">Linear warranty after second year: with 0.54% annual degradation 85% is guaranteed up to 25 years
                </li>
            </ul>
            <ul> <h1>Key Features</h1>
                <li className="specsText">Higher yield per surface area, lower BOS costs, higher power classes, and an efficiency rate of up to 20.3 %.</li>
                <li className="specsText">Optimal yields, whatever the weather with excellent low-light and temperature behaviour.</li>
                <li className="specsText">Long-term yield security with Anti LID Technology, Anti PID Technology1, Hot-Spot Protect and Traceable Quality Tra.QTM.</li>
                <li className="specsText">High-tech aluminium alloy frame, certified for high snow (5400 Pa) and wind loads (2400 Pa).
                </li>
                <li className="specsText">Q.ANTUM DUO combines cutting edge cell separation and innovative wiring with Q.ANTUM Technology.</li>
                <li className="specsText">Hyundai’s R&D center is an accredited test laboratory of both UL and VDE.</li>
                <li className="specsText">{moduleLink}</li>
            </ul>
        </div>
    </div>
);

export default Module;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/SystemSpecs/Panels/hyu400s.js